// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import { localize } from '@ta/common.i18n';

import type { InternalContentProps } from './base';
import { DefaultProps, defaultConnect } from './base';

import ReportIAPPanel from '../ReportIAPPanel';
import { ContentType } from '../submit/SubmitIapVote';

const ReportPhotoPanel = (props: InternalContentProps) => (
  <ReportIAPPanel
    csrfToken={props.csrfToken}
    userId={props.userId}
    contentId={props.contentId}
    contentType={ContentType.MEDIA}
    onError={props.onError}
    onComplete={props.onComplete}
    repostInfo={props.repostInfo}
  >
    {panel => (
      <React.Fragment>
        {panel.createRadioWithOptionalComment('PROFANE_EXPLICIT_HATE_SPEECH')}
        {panel.createRadioWithOptionalComment('PARTICIPATION_ILLEGAL_ACTIVITY')}
        {panel.createRadioWithOptionalComment('LOW_QUALITY')}
        {panel.createRadioWithSuggestionBox('WRONG_LOCATION', localize('social_report_level2_3'))}
        {panel.createRadioWithOptionalComment('DUPLICATE_CONTENT')}
        {panel.createRadioWithOptionalComment('COPYRIGHT_VIOLATION')}
        {panel.createRadioWithRequiredComment('OTHER')}
      </React.Fragment>
    )}
  </ReportIAPPanel>
);
ReportPhotoPanel.defaultProps = DefaultProps;

// $FlowFixMe92
export default connect(state => defaultConnect(state))(ReportPhotoPanel);
